import { Subject, takeUntil, tap } from "rxjs";

import { errorMessages, msgGen } from "../shared/errorMessages";
import { IRemoteItemStoreConfig, IRemoteItemStoreOptions } from "../types";
import { AllowedKeyType } from "../types/key-types";



export class RemoteItemStore<TModel extends object, TKeyType extends AllowedKeyType = string> implements IRemoteItemStoreOptions<TModel, TKeyType> {

  private readonly _destroy = new Subject<void>();

  keyValue?: TKeyType;

  // constructor(collectionCustomStore: RemoteCollectionStore<Model, KeyType>);
  // constructor(options: IRemoteItemStoreOptions<Model, KeyType>);
  constructor(
    private _options: IRemoteItemStoreConfig<TModel, TKeyType>
  ) {

    this.keyValue = _options.keyValue;
  }

  load() {
    const keyValue = this.keyValue;

    if (!this._options.load) {
      throw { message: msgGen.METHOD_NOT_IMPLEMENTED('load') }
    }

    if (!keyValue) {
      throw { message: errorMessages.KEY_DOES_NOT_HAVE_A_VALUE }
    }

    return this._options.load(keyValue)
  }

  update(updateJSON: Partial<TModel>) {
    const keyValue = this.keyValue;

    if (!this._options.update) {
      throw { message: msgGen.METHOD_NOT_IMPLEMENTED('update') }
    }

    if (!keyValue) {
      throw { message: errorMessages.KEY_DOES_NOT_HAVE_A_VALUE }
    }

    return this._options.update(keyValue, updateJSON)
  }

  insert(insertJSON: Partial<TModel>) {

    if (!this._options.insert) {

      throw { message: msgGen.METHOD_NOT_IMPLEMENTED('insert') }
    }

    const insertObs = this._options?.insert(insertJSON);

    return insertObs.pipe(
      takeUntil(this._destroy),
      tap((key) => this.keyValue = key)
    );
  }

  remove() {
    if (!this._options.remove) {
      throw { message: msgGen.METHOD_NOT_IMPLEMENTED('remove') }
    }

    if (!this.keyValue) {
      throw { message: errorMessages.KEY_DOES_NOT_HAVE_A_VALUE }
    }

    return this._options.remove(this.keyValue)
  };

  dispose() {
    this._destroy.next();
    this._destroy.complete();
  }



}

